import React from "react";
import { UserPictureCache } from "Hooks";
import { AvatarCircleWithCache } from "Components/AvatarCircle";
import { ActivityProperties } from "./types";
import classes from "./ActivityMarker.module.scss";

interface ActivityMarkerProps {
   activity: ActivityProperties;
   pictureCache: UserPictureCache;
}

const ActivityMarker: React.FC<ActivityMarkerProps> = ({
   activity,
   pictureCache,
}) => {
   const { memberFullName, memberEmail, memberId } = activity;
   const [firstName, lastName] = (memberFullName ?? "").split(" ");

   return (
      <AvatarCircleWithCache
         cache={pictureCache}
         userId={memberId}
         firstName={firstName}
         lastName={lastName}
         email={memberEmail ?? "Unknown"}
         className={classes.activityContainer}
      />
   );
};

export default ActivityMarker;
